import React, { useState } from "react";
import MenuBar from "../common/MenuPanel";
import FooterPanel from "../common/FooterPanel";
import prayersData from "../../source/prayers.json";

// Reusable PrayerSection component
const PrayerSection = ({ title, expanded, toggle, content }) => (
  <div className="prayer-section mt-4 mb-4">
    <h2 className="prayer-title clickable" onClick={toggle}>
      {expanded ? "▲ " : "▼ "} {title}
    </h2>
    {expanded && (
      <div className="prayer-text ">
        {content.map((line, index) => (
          <p key={index}>{line}</p>
        ))}
      </div>
    )}
  </div>
);

// Reusable Intro Section
const ScripturalPrayersIntro = () => (
  <div className="prayer-intro">
    <p>
      <br />
      <strong>Daily and devout reading of the Scriptures</strong> and treasuring
      them in our hearts is a sure means to grow in one’s spiritual life. When
      we read the Scriptures, we come into contact with the
      <strong> living and enduring Word of God</strong>, by which we are
      constantly renewed in our spiritual journey.


    <h3 className="text-primary  text-center mt-2">Prayer in the Word of God</h3>

    <blockquote className="scripture-quote">
      <i>
        "All Scripture is inspired by God and is useful for teaching, for
        refutation, for correction, and for training in righteousness, so that
        one who belongs to God may be competent, equipped for every good work."
        (2 Timothy 3:16-17)
      </i>
    </blockquote>


      On our spiritual journey, <strong>constant prayer</strong> is of great
      importance (1 Thessalonians 5:17). Reading and meditating on the
      Scripture is the greatest form of prayer (Luke 2:19; John 4:23-24).
      <strong> Prayer in the Word of God</strong> has immense power (Psalms
      119:9-11) because:
    </p>

    <ul className="prayer-points">
      <li>
        <strong>The Word of God is Jesus</strong> (John 1:1-3; Revelation 19:13).
      </li>
      <li>
        <strong>The Word of God is Spirit and Life</strong> (John 6:63).
      </li>
      <li>
        <strong>The Word of God is Truth</strong> (John 17:17).
      </li>
      <li>
        <strong>
          The Word of God is a lamp to our feet and a light to our path
        </strong>{" "}
        (Psalms 119:105).
      </li>
      <li>
        <strong>The Word of God is a double-edged sword</strong> (Hebrews 4:12).
      </li>
      <li>
        <strong>The Word of God is Jesus Himself.</strong> When we read the
        Bible, it is Jesus who speaks to us. St. Ambrose said,
        <em> “We address Him when we pray; we hear Him when we read.”</em>
        Like the prophet Samuel, we should pray:{" "}
        <em>“Speak, Lord, your servant is listening.”</em> (1 Samuel 3:10).
      </li>
      <li>
        <strong>The Word of God is Spirit.</strong> When we pray and meditate on
        the Scriptures, we are filled with the Holy Spirit and come to
        understand the mind of God (Acts 10:44; Romans 8:26-27; Wisdom 9:17).
      </li>
      <li>
        <strong>The Word of God is the Truth</strong> that sets all people free
        (John 8:32; John 14:6). Many errors come from ignorance of the
        Scriptures (Matthew 22:29; Mark 12:24).
      </li>
    </ul>
  </div>
);

const WOGPage = () => {
  const [expandedSections, setExpandedSections] = useState({});

  const toggleSection = (sectionId) => {
    setExpandedSections((prev) => ({
      ...prev,
      [sectionId]: !prev[sectionId],
    }));
  };

  return (
    <>
      {/* Menu */}
      <div className="container-fluid position-relative p-0">
        <MenuBar />
      </div>

      {/* Title Section with Overlay */}
      <div className="container-fluid p-0">
        <div
          className="banner-image_sm"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/2.png)`,
          }}
        >
          <div className="banner-heading text-center wow fadeInDown">
            <h1 className="text-white">Scriptural Prayers</h1>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="prayers-content container mt-3 mb-2">
        <ScripturalPrayersIntro />

        {/* Prayer Sections */}
        {prayersData
          .filter((prayer) => prayer.type === "wog")
          .map((prayer) => (
            <PrayerSection
              key={prayer.id}
              title={prayer.title}
              expanded={expandedSections[prayer.id]}
              toggle={() => toggleSection(prayer.id)}
              content={prayer.text}
            />
          ))}
      </div>

      {/* Footer */}
      <FooterPanel />
    </>
  );
};

export default WOGPage;
